import * as React from "react";
import { WrappedFieldProps } from "redux-form";
import { Link } from "react-router-dom";
import InputRange from "react-input-range";
import RangeButtonsMobileHelpers from "./RangeButtonsMobileHelpers";
import Parser from "html-react-parser";
import { RiskDegrees } from "Models/Dictionary";

type Props = {
  label: string;
  disabled: boolean;
  description: string;
  iconSrc: string;
  min: number;
  max: number;
  icon: string;
  formatLabel?: (val: any) => string;
  searchTypePopup: string;
  setSearchTypePopup: (type: string) => void;
  type: string;
};

type S = {
  riskDescriptionVisible: boolean;
  interestDescriptionVisible: boolean;
  min: any | number;
  max: any | number;
  rangeClass: string;
};

class RangeField extends React.PureComponent<WrappedFieldProps & Props, S> {
  constructor(props) {
    super(props);
    this.state = {
      riskDescriptionVisible: false,
      interestDescriptionVisible: false,
      min: this.props.input.value.min,
      max: this.props.input.value.max,
      rangeClass: "",
    };
  }

  public toggleDescription = () => {
    this.props.setSearchTypePopup(this.props.input.name);
    // console.log(this.state.riskDescriptionVisible);
    // setTimeout(() => {
    //   if (this.props.searchTypePopup === this.props.input.name) {
    //     this.props.setSearchTypePopup("");
    //   }
    // }, 10000);
  };

  public hideDescription = () => { 
      this.props.setSearchTypePopup("");
  };
  public rangeMinIncrementUpdate = () => {
    const { input } = this.props;
    if (input.value.min + 1 < input.value.max) {
      this.setState({ min: input.value.min + 1 });
      input.onChange({ min: input.value.min + 1, max: input.value.max });
      this.distance(input.value.min + 1, input.value.max);
    }
  };
  public rangeMinDecrementUpdate = () => {
    const { input } = this.props;
    if (input.value.min - 1 > 0) {
      this.setState({ min: input.value.min - 1 });
      input.onChange({ min: input.value.min - 1, max: input.value.max });
      this.distance(input.value.min - 1, input.value.max);
    }
  };
  public rangeMaxIncrementUpdate = () => {
    const { input } = this.props;
    if (input.value.max + 1 <= this.props.max) {
      this.setState({ max: input.value.max + 1 });
      input.onChange({ min: input.value.min, max: input.value.max + 1 });
      this.distance(input.value.min, input.value.max + 1);
    }
  };
  public rangeMaxDecrementUpdate = () => {
    const { input } = this.props;
    if (input.value.max - 1 > input.value.min) {
      this.setState({ max: input.value.max - 1 });
      input.onChange({ min: input.value.min, max: input.value.max - 1 });
      this.distance(input.value.min, input.value.max - 1);
    }
  };
  public timer: any = 0;
  public reg: any = /^\d+$/;
  public changeRangeMin = (event) => {
    const { input } = this.props;
    if (!this.reg.test(event.currentTarget.value)) {
      return;
    }
    clearTimeout(this.timer);
    this.setState({ min: event.currentTarget.value });
    if (
      event.currentTarget.value === "" ||
      event.currentTarget.value === "0" ||
      !this.reg.test(event.currentTarget.value)
    ) {
      this.timer = setTimeout(
        () => {
          input.onChange({ min: 1, max: input.value.max });
          this.setState({ min: 1 });
        },
        this.reg.test(event.currentTarget.value) ? 2000 : 500
      );
    } else if (event.currentTarget.value >= this.props.max) {
      this.timer = setTimeout(() => {
        input.onChange({ min: input.value.max - 1, max: input.value.max });
        this.setState({ min: input.value.max - 1 });
      }, 2000);
    } else if (
      event.currentTarget.value < input.value.max &&
      event.currentTarget.value > 0
    ) {
      input.onChange({
        min: parseFloat(event.currentTarget.value),
        max: input.value.max,
      });
    }
  };
  public changeRangeMax = (event) => {
    if (
      event.target.value == "" ||
      event.target.value.match(/^[1-9]\d*\.?\d*$/)
    ) {
      this.setState({ max: event.currentTarget.value });
    }
    const { input } = this.props;
    if (!this.reg.test(event.currentTarget.value)) {
      return;
    }
    clearTimeout(this.timer);
    this.setState({ max: event.currentTarget.value });

    if (event.currentTarget.value <= input.value.min) {
      this.timer = setTimeout(() => {
        this.setState({ max: input.value.min + 1 });
        input.onChange({ min: input.value.min, max: input.value.min + 1 });
      }, 2000);
    }
    if (
      event.currentTarget.value > this.props.max ||
      !this.reg.test(event.currentTarget.value)
    ) {
      this.timer = setTimeout(
        () => {
          this.setState({ max: this.props.max });
          input.onChange({ min: input.value.min, max: this.props.max });
        },
        this.reg.test(event.currentTarget.value) ? 2000 : 500
      );
    }
    if (
      event.currentTarget.value > input.value.min &&
      event.currentTarget.value <= this.props.max
    ) {
      input.onChange({
        max: parseFloat(event.currentTarget.value),
        min: input.value.min,
      });
    }
    this.distance(this.state.min, event.currentTarget.value);
  };

  public distance = (min, max) => {
    const { type } = this.props;
    // const { min, max } = this.state;
    if (type == "profit") {
      if (max - min <= 4) {
        this.setState({ rangeClass: "profit" });
      } else {
        this.setState({ rangeClass: "" });
      }
    }
    if (type == "time") {
      if (max - min <= 10) {
        this.setState({ rangeClass: "time" });
      } else {
        this.setState({ rangeClass: "" });
      }
    }
    console.log(max);
  };
  public render() {
    const { input, meta, label, disabled, description, icon } = this.props;
    let formClasses: string = "form_field input--range";

    formClasses += meta.error && meta.touched ? " form_field--has_error" : "";
    formClasses += disabled ? " form_field--disabled" : "";
    const value = input.value;
    return (
      <div className={formClasses}>
        <div className="input--range__heading">
          {/* <div className="input--range__icon">{input.name === "risk" && <i onClick={this.toggleRiskDescription} className="far fa-question-circle more-info" />}</div> */}
          <div className="input--range__name">
            {input.name === "risk" ||
            input.name === "interest" ||
            input.name === "duration" ? (
              <img src={icon} alt="" />
            ) : (
              <i className={icon} />
            )}
            <label>
              {/* {label} <span>{(input.name === "risk" || input.name === "interest") && <i onClick={input.name === "interest" ? this.toggleRiskDescription : this.toggleInterestDescription} className="far fa-question-circle more-info" />}</span> */}
              {label}{" "}
              <span>
                {input.name === "risk" || input.name === "duration" ? (
                  <i
                    onMouseEnter={this.toggleDescription}
                    onMouseLeave={this.hideDescription}
                    className="far fa-question-circle more-info"
                  />
                ) : (
                  input.name === "interest" && (
                    <i
                      onMouseEnter={this.toggleDescription}
                      onMouseLeave={this.hideDescription}
                      className="far fa-question-circle more-info"
                    />
                  )
                )}
              </span>
            </label>
            {/* <p className="input--range__description">{description}</p> */}
            {input.name === "risk" ? (
              <p className="input--range__description--risk">
                <span>1 - niski</span> <span>10 - bardzo wysoki</span>
              </p>
            ) : (
              <p className="input--range__description">{Parser(description)}</p>
            )}
          </div>
        </div>
        {input.name === "risk" && (
          <div
            onMouseEnter={this.toggleDescription}
            onMouseLeave={this.hideDescription}
            className={`risk-description ${
              this.props.searchTypePopup === "risk" ? "show" : "hidden"
            }`}
          >
            {/* <p>1. Kruszce przechowywane samodzielnie przez Klienta.</p>
            <p>2. Kamienie szlachetne przechowywane samodzielnie przez Klienta.</p>
            <p>3. Inwestycje nieruchomościowe zabezpieczone hipotecznie z oddzielną księga wieczystą.</p>
            <p>4. Numizmatyka przechowywana samodzielnie przez Klienta.</p>
            <p>5. Inwestycje nieruchomościowe zabezpieczone hipotecznie bez odrębnej księgi wieczystej.</p>
            <p>6. Pojazdy przechowywane przez Klienta.</p>
            <p>7. Whisky przechowywana przez Klienta.</p>
            <p>8. Inwestycje nieruchomościowe bez zabezpieczenia hipotecznego.</p>
            <p>9. Inwestycje w biznes franczyzowy.</p>
            <p>10. Tokeny</p> */}
            {RiskDegrees.map((riskDegree: any, idx: number) => (
              <p key={idx}>
                {idx + 1}. {riskDegree}
              </p>
            ))}
            <i className="fas fa-tachometer-alt risk" />
          </div>
        )}
        {input.name === "interest" && (
          <div
            onMouseEnter={this.toggleDescription}
            onMouseLeave={this.hideDescription}
            className={`interest-description ${
              this.props.searchTypePopup === "interest" ? "show" : "hidden"
            }`}
          >
            Inwestowanie wiąże się z wysokim ryzykiem, m. in.: braku płynności,
            braku dywidend, utratą części lub całości zainwestowanych środków.
            Inwestycje powinny się odbywać tylko w ramach zdywersyfikowanego
            portfela. Ta platforma jest skierowana wyłącznie do inwestorów,
            którzy posiadają wystarczającą wiedzę, aby zrozumieć ryzyka i
            podejmować własne decyzje inwestycyjne. Oferty przedstawione na
            platformie są dostępne wyłącznie dla zarejestrowanych użytkowników.
            Informacje zawarte na stronie zostały dostarczone przez oferentów,
            którzy ponoszą całkowitą odpowiedzialność za ich treść. Potencjalny
            zysk został określony przez poszczególnych oferentów. Obligain nie
            bierze odpowiedzialności za informacje dostarczone przez oferentów,
            ani za ich rekomendacje i opinie. Kliknij{" "}
            <Link className="color-brown" to="/risk-warnings">
              tutaj
            </Link>
            , aby przeczytać pełne Ostrzeżenie o ryzyku.
          </div>
        )}
        {input.name === "duration" && (
          <div
            onMouseEnter={this.toggleDescription}
            onMouseLeave={this.hideDescription}
            className={`duration-description ${
              this.props.searchTypePopup === "duration" ? "show" : "hidden"
            }`}
          >
            Deklarowany przez Oferenta czas trwania inwestycji
          </div>
        )}
        {/* {isMobile && ( */}
        <div className="input--range__mobile-actions">
          <div className="input--range__mobile-actions--counter">
            <input
              className={"RangeButtonsCounter"}
              onChange={this.changeRangeMin}
              id={input.name}
              value={this.state.min}
              pattern="[0-9]*"
            />
            {(meta.touched && meta.error && (
              <div className="form_field--error_wrapper">
                <span className="form_field--error">{meta.error}</span>
              </div>
            )) ||
              (meta.warning && <span>{meta.warning}</span>)}
            <input
              className={"RangeButtonsCounter"}
              onChange={this.changeRangeMax}
              id={input.name}
              value={this.state.max}
              pattern="[0-9]*"
            />
            {(meta.touched && meta.error && (
              <div className="form_field--error_wrapper">
                <span className="form_field--error">{meta.error}</span>
              </div>
            )) ||
              (meta.warning && <span>{meta.warning}</span>)}

            {/* <div className={"RangeButtonsCounter"}>{input.value.min}</div>
            <div className={"RangeButtonsCounter"}>{input.value.max}</div> */}
          </div>
          <div className="input--range__mobile-actions--increment">
            <RangeButtonsMobileHelpers
              classNames="input--range__mobile-actions--reduce"
              onButtonPress={this.rangeMinDecrementUpdate}
              onChange={this.rangeMinDecrementUpdate}
            >
              {/* <span>-</span> */}-
            </RangeButtonsMobileHelpers>
            <RangeButtonsMobileHelpers
              classNames="input--range__mobile-actions--reduce"
              onButtonPress={this.rangeMaxDecrementUpdate}
              onChange={this.rangeMaxDecrementUpdate}
            >
              {/* <span>-</span> */}-
            </RangeButtonsMobileHelpers>
          </div>
          <div className="input--range__mobile-actions--decrement">
            <RangeButtonsMobileHelpers
              onButtonPress={this.rangeMinIncrementUpdate}
              classNames="input--range__mobile-actions--add"
              onChange={this.rangeMinIncrementUpdate}
            >
              +
            </RangeButtonsMobileHelpers>
            <RangeButtonsMobileHelpers
              onButtonPress={this.rangeMaxIncrementUpdate}
              classNames="input--range__mobile-actions--add"
              onChange={this.rangeMaxIncrementUpdate}
            >
              +
            </RangeButtonsMobileHelpers>
          </div>
        </div>
        {/* )} */}
        <div className={`input--range__distance--${this.state.rangeClass}`}>
          <InputRange
            minValue={this.props.min}
            maxValue={this.props.max}
            formatLabel={this.props.formatLabel}
            value={value}
            onChange={(newVal: any) => {
              this.setState({ min: newVal.min, max: newVal.max });
              input.onChange(newVal);
              this.distance(this.state.min, this.state.max);
            }}
          />
          {(meta.touched && meta.error && (
            <div className="form_field--error_wrapper">
              <span className="form_field--error">{meta.error}</span>
            </div>
          )) ||
            (meta.warning && <span>{meta.warning}</span>)}
        </div>
        {input.name === "risk" && (
          <div className="input--range__risk-degrees">
            {value.min > 0 && (
              <p>
                <span>{input.value.min}.</span>
                {RiskDegrees[input.value.min - 1]}
              </p>
            )}
            <p>
              <span>{input.value.max}.</span> {RiskDegrees[input.value.max - 1]}
            </p>
          </div>
        )}
      </div>
    );
  }
}

export default RangeField;

// const mapDispatchToProps: DispatchedP = {
//   setSearchTypePopup: (type: string) => ViewManagementModule.Actions.setSearchTypePopup(type)
// };

// function mapStateToProps(state: RootState): ConnectedP {
//   return {
//     searchTypePopup: state.viewManagementStore.searchTypePopup
//   };
// }

// export default connect(mapStateToProps, mapDispatchToProps)(RangeField);



// WEBPACK FOOTER //
// ./src/components/Forms/Fields/RangeField.tsx